module.exports = __webpack_public_path__ + "static/mission-2b89112a1505b40871c5e3188cad880e.png";